<script>
import { mapActions } from "vuex";
import { required } from '@vuelidate/validators';
import SupplierGroup from "@/models/SupplierGroup.vue"

import BaseSupplierGroupDialogSelector from "@/components/shared/BaseDialogSelectors/BaseSupplierGroupDialogSelector.vue";

export default {
  extends: SupplierGroup,
  components: {
    BaseSupplierGroupDialogSelector,
  },
  computed: {
    title() {
      return this.id ? `Edit ${this.modelName}` : `Create ${this.modelName}`
    }
  },
  data() {
    return {
      showModal: false,
      binaryOptions: [
        { text: "Parent", value: true, },
        { text: "Child", value: false, },
      ],
    };
  },
  methods: {
    ...mapActions('supplierGroups', ['upsertSupplierGroup']),
    ...mapActions("application", ["setIsConfirmLoading"]),

    async show() {
      this.initialize();
      this.showModal = true;
    },

    async upsert(e) {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        this.setIsConfirmLoading(true);
        try {
          if (this.is_parent) { this.parent = null; }
          await this.upsertSupplierGroup(this.supplier_group);
          this.$emit('upserted')
          this.showModal = false
        } catch {
        } finally {
          this.setIsConfirmLoading(false);
        }
      }
    }
  },
  watch: {
    showModal() {
      this.v$.$reset();
    }
  },
  validations() {
    return this.showModal
      ? {
          name: { required },
        }
      : { };
  },
};
</script>

<template>
  <div>
    <base-modal v-model="showModal" :title="title" @upsert="upsert">
      <form @submit.prevent="upsert">
        <div class="row">
          <div class="col-sm-12">
            <div class="row mb-2">
              <div class="col-sm-12">
                <base-input
                  label="Name"
                  type="text"
                  v-model="name"
                  :validation="v$.name"
                  required
                />
              </div>
            </div>

            <div class="row gap-2 gap-sm-0">
              <div class="col-sm-6">
                <base-binary-button
                  id="parent"
                  label="Group Hierarchy"
                  variant="primary"
                  falseLabel="Child"
                  trueLabel="Parent"
                  v-model="is_parent"
                ></base-binary-button>
              </div>
              <div class="col-sm-6" v-if="is_parent == false">
                <BaseSupplierGroupDialogSelector v-model="parent" disableAdd disableModals disableQuickAdd />
              </div>
            </div>
          </div>
        </div>
      </form>
    </base-modal>
  </div>
</template>